import $ from 'jquery'

const SELECTORS = {
    qtySelector: '[data-quantity-select]',
    adjustBtn: '[data-quantity-select-adjust]'
}

function qtySelectors() {
    const $qtySelectors = $(SELECTORS.qtySelector)
    const $adjustBtns = $(SELECTORS.adjustBtn, $qtySelectors)

    $adjustBtns.on('click', function () {
        const $input = $(this).siblings('input')
        const operation = $(this).data('operation')
        const minValue = parseInt($input.attr('min'), 10)
        const previousValue = parseInt($input.val(), 10)

        let newValue = previousValue
        if (operation === 'increment') {
            newValue = previousValue + 1
        } else if (operation === 'decrement' && previousValue > minValue) {
            newValue = previousValue - 1
        }

        $input.val(newValue)
    })
}

$(document).ready(() => qtySelectors())
